/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useMemo, useEffect } from "react";

import { bem } from "../../../shared/BEM";
import { FormComponent } from "../Form/FormComponent";
import { DocumentManager } from "../../lib/DocumentManager";
import { useHistory } from "react-router-dom";
import { FormActionBarComponent } from "../Form/FormActionBarComponent";

/**
 * Component props
 */
export interface IPageFormComponentProps {
	docMgr: DocumentManager;
	docId: string;
}

/**
 * Menu section
 *
 * @param props Component props
 */
export function PageForm(props: IPageFormComponentProps) {

	const history = useHistory();

	const formModel = useMemo(() =>
		props.docMgr.get(props.docId),
	[ props.docId, props.docMgr ]);

	/* Handle document close - redirect to homepage or previous document */
	useEffect(() => {

		const handleClose = (ev) => {

			if (ev.docId === props.docId) {

				if (ev.nextDocId) {
					history.push("/doc/" + ev.nextDocId);
				} else {
					history.push("/");
				}

			}

		};

		props.docMgr.on("close", handleClose);

		return () => {
			props.docMgr.off("close", handleClose);
		};

	}, [ props.docId, props.docMgr ]);

	return <div className={bem("page", null, "form").str}>
		{ formModel ?
		<>
			<FormComponent model={formModel} />
			<FormActionBarComponent model={formModel} />
		</>
		:
		<>
			<p>Document not found.</p>
		</>
		}
	</div>;

}
